import { FC } from 'react';

import BasicModal from 'components/Common/BasicModal';

import { Props } from './types';

import { Box } from '@mui/material';
import checkedIcon from 'assets/images/icons/checked.svg';
import SingleNews from './SingleNews';
import { NEWS } from 'utils/config/constants/controllerNames';
import { auth, onUpdateDoc } from 'utils/config/firebase';
import { getTranslatedNews } from 'helpers/news';

const NewsModal: FC<Props> = ({ open, news }) => {
    const onSubmit = () => {
        onUpdateDoc(NEWS, news.document_id, {
            users: [...news.users, auth?.currentUser?.uid],
        });
    };

    const showTranslatedNews = (name: string) => getTranslatedNews(news.document_id, name);
    return (
        <BasicModal
            open={open}
            onClose={() => {
                console.log("don't close");
            }}
            modalClass="add-scroll"
            sx={{
                position: 'absolute' as const,
                left: '50%',
                transform: 'translate(-50%, 0%)',
                overflow: 'auto',
                p: 4,
            }}
        >
            <Box className="news-modal">
                <Box className="news-modal-header">
                    <h2>{showTranslatedNews('header') || news.header}</h2>
                    <h3>
                        {showTranslatedNews('header_description.title') ||
                            news.header_description.title}
                    </h3>
                    <Box>
                        <ul>
                            {news.header_description.items.map((item, i) => (
                                <li key={item}>
                                    <img src={checkedIcon} alt="checked" />
                                    {showTranslatedNews(`header_description.items[${i}]`) || item}
                                </li>
                            ))}
                        </ul>
                    </Box>
                </Box>
                <Box className="news-modal-body">
                    {news.body.map((item, i) => (
                        <SingleNews
                            key={item.title}
                            item={item}
                            showTranslatedNews={showTranslatedNews}
                            index={i}
                        />
                    ))}
                    <Box className="news-modal-body-btn">
                        <button onClick={onSubmit}>Got it</button>
                    </Box>
                </Box>
            </Box>
        </BasicModal>
    );
};

export default NewsModal;
